import { render, staticRenderFns } from "./UiCard.vue?vue&type=template&id=2b839f6e&scoped=true"
import script from "./UiCard.vue?vue&type=script&setup=true&lang=js"
export * from "./UiCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b839f6e",
  null
  
)

export default component.exports